import debounce from 'lodash/debounce'
import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { unixFromNow, perPageFeedback } from '../../../utils'

/*
const sampleSummary = {
  countSuccess: 39,
  countFail: 1,
  amount: 1234567.8
}
*/
/*
const sampleList = [{
  id: 'someId',
  time: '今天19:35',
  name: '王菲',
  amount: 123.45,
  success: true
}, {
  id: 'someId',
  time: '昨天19:35',
  name: '王菲',
  amount: 6123.45,
  success: true
}, {
  id: 'someId',
  time: '2016.2.14',
  name: '王菲',
  amount: 123.45,
  success: false
}]
*/

const debouncedSearch = debounce(api.cf.getFeedbackList, 300)

const state = {
  countSuccess: 0,
  countFail: 0,
  amount: 0,

  list: [],

  currentPage: 1,
  hasMore: true
}

const mapList = i => {
  return {
    id: i.id,
    time: unixFromNow(i.pay_time || i.create_time),
    name: i.donate_form_data ? i.donate_form_data.name : (i.contact ? i.contact.name : '无'),
    amount: i.donate_amount,
    statusText: i.status_text,
    success: i.status === 'paid'
  }
}

const actions = {
  [aTypes.CF_GET] ({ commit, dispatch }, id) {
    commit(mTypes.SET_LOADING, { key: aTypes.CF_GET, loading: true })
    api.cf.getOne({
      success (res) {
        commit(mTypes.SET_NAV_TITLE, res.body.title)
        commit(mTypes.CF_SET_FEEDBACK_SUMMARY, {
          countSuccess: res.body.count_user_paid,
          countFail: 0,
          amount: res.body.sum_paid
        })
        commit(mTypes.SET_LOADING, { key: aTypes.CF_GET, loading: false })
        dispatch(aTypes.ZHUGE_TRACK, {
          event: '到达筹款反馈列表页',
          data: {
            '筹款名称': res.body.title,
            '筹款提交人次': res.body.count_user_paid,
            '筹款金额': res.body.sum_paid
          }
        })
      },
      commit
    }, id)
  },
  [aTypes.CF_GET_FEEDBACK_LIST] ({ commit }, { id, page, append, searchName }) {
    commit(mTypes.SET_LOADING, { key: aTypes.CF_GET_FEEDBACK_LIST, loading: true })
    const search = searchName ? debouncedSearch : api.cf.getFeedbackList
    search({
      success (res) {
        const list = res.body.data.map(mapList)
        const pagination = res.body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.CF_SET_FEEDBACK_LIST, { list, page, hasMore, append })
        commit(mTypes.SET_LOADED_ID_OF_CF_FEEDBACK, id)
        commit(mTypes.SET_LOADING, { key: aTypes.CF_GET_FEEDBACK_LIST, loading: false })
      },
      commit
    }, { id, page, perPage: perPageFeedback, searchName })
  }
}

const mutations = {
  [mTypes.CF_SET_FEEDBACK_LIST] (state, { list, page, hasMore, append }) {
    if (append) {
      state.list = state.list.concat(list)
    } else {
      state.list = list
    }
    state.currentPage = page
    state.hasMore = hasMore
  },
  [mTypes.CF_SET_FEEDBACK_SUMMARY] (state, { countSuccess, countFail, amount }) {
    state.countSuccess = countSuccess
    state.countFail = countFail
    state.amount = amount
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cf/feedback.js